import { Routes } from "@angular/router";
import { BrokersListComponent } from "app/brokers/component/brokers-list/brokers-list.component";
import { LayoutComponent } from "app/shared/components/layout/layout.component";
import { MsalGuard } from '@azure/msal-angular';
import { BrokersAddComponent } from "./component/brokers-add/brokers-add.component";

export const BROKERS_ROUTES: Routes = [
	{
        path: 'brokers',
		component: LayoutComponent,
		canActivate: [MsalGuard],
        children: [
            { path: '', component: BrokersListComponent },
            { path: 'add', component: BrokersAddComponent }
		]
	}
];
